import React from 'react'

const City = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2a1 1 0 011 1v18a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h9zm-.5 1.5h-8v17h8v-17zM6.5 17v1.5H5V17h1.5zm3 0v1.5H8V17h1.5zm-3-4v1.5H5V13h1.5zm3 0v1.5H8V13h1.5zm-3-4v1.5H5V9h1.5zm3 0v1.5H8V9h1.5zm-3-4v1.5H5V5h1.5zm3 0v1.5H8V5h1.5zm11 5a1 1 0 011 1v10a1 1 0 01-1 1h-8a1 1 0 01-1-1V11a1 1 0 011-1h8zm-.5 1.5h-7v9h7v-9zM15.5 17v1.5H14V17h1.5zm3 0v1.5H17V17h1.5zm-3-4v1.5H14V13h1.5zm3 0v1.5H17V13h1.5z" fill={props.fill || '#1A344F'} fillRule="nonzero"/></svg>
)

export default City
